module.exports = __webpack_public_path__ + "img/cdq2b25-01.prt.d16cef08.jpg";